import MuiList, { type ListProps } from "@mui/material/List";
import MuiListItem, { type ListItemProps } from "@mui/material/ListItem";
import MuiListItemButton, { type ListItemButtonProps } from "@mui/material/ListItemButton";
import MuiListItemIcon, { type ListItemIconProps } from "@mui/material/ListItemIcon";
import MuiListItemText, { type ListItemTextProps } from "@mui/material/ListItemText";
import MuiListItemAvatar, { type ListItemAvatarProps } from "@mui/material/ListItemAvatar";
import MuiListSubheader, { type ListSubheaderProps } from "@mui/material/ListSubheader";
import MuiListItemSecondaryAction, { type ListItemSecondaryActionProps } from "@mui/material/ListItemSecondaryAction";

export type {
  ListProps,
  ListItemProps,
  ListItemButtonProps,
  ListItemIconProps,
  ListItemTextProps,
  ListItemAvatarProps,
  ListSubheaderProps,
  ListItemSecondaryActionProps,
};

export function List(props: ListProps) {
  return <MuiList {...props} />;
}

export function ListItem(props: ListItemProps) {
  return <MuiListItem {...props} />;
}

export function ListItemButton(props: ListItemButtonProps) {
  return <MuiListItemButton {...props} />;
}

export function ListItemIcon(props: ListItemIconProps) {
  return <MuiListItemIcon {...props} />;
}

export function ListItemText(props: ListItemTextProps) {
  return <MuiListItemText {...props} />;
}

export function ListItemAvatar(props: ListItemAvatarProps) {
  return <MuiListItemAvatar {...props} />;
}

export function ListSubheader(props: ListSubheaderProps) {
  return <MuiListSubheader {...props} />;
}

export function ListItemSecondaryAction(props: ListItemSecondaryActionProps) {
  return <MuiListItemSecondaryAction {...props} />;
}
